import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Suitcase(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Suitcase", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M30.1615 16.2c-.2383 0-.4669-.0913-.6354-.2538-.1685-.1625-.2632-.383-.2632-.6128v-2.6001H18.4794v2.6001c0 .2298-.0947.4503-.2632.6128-.1685.1625-.3971.2538-.6354.2538-.2384 0-.4669-.0913-.6355-.2538-.1685-.1625-.2632-.383-.2632-.6128v-3.4667c0-.2299.0947-.4503.2632-.6129.1686-.1625.3971-.2538.6355-.2538h12.5807c.2383 0 .4669.0913.6354.2538.1686.1626.2632.383.2632.6129v3.4667c0 .2298-.0946.4503-.2632.6128-.1685.1625-.3971.2538-.6354.2538ZM5 17.9334v18.2002c0 .2298.09468.4503.2632.6128.16853.1625.3971.2538.63543.2538H41.8436c.2384 0 .4669-.0913.6355-.2538.1685-.1625.2632-.383.2632-.6128V17.9334H5Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M5.89863 14.4668H41.8436c.2384 0 .4669.0913.6355.2538.1685.1626.2632.383.2632.6129v2.6c0 2.2986-.9468 4.503-2.632 6.1283-1.6853 1.6253-3.971 2.5384-6.3543 2.5384H13.9863c-2.3833 0-4.66904-.9131-6.35429-2.5384C5.94676 22.4365 5 20.2321 5 17.9335v-2.6c0-.2299.09468-.4503.2632-.6129.16853-.1625.3971-.2538.63543-.2538Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M18.4794 25.7339h-3.5945c-.4963 0-.8986.388-.8986.8667v2.6c0 .4786.4023.8667.8986.8667h3.5945c.4963 0 .8986-.3881.8986-.8667v-2.6c0-.4787-.4023-.8667-.8986-.8667Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M17.5807 26.6h-1.7972c-.2482 0-.4493.194-.4493.4334v1.7333c0 .2393.2011.4334.4493.4334h1.7972c.2482 0 .4493-.1941.4493-.4334v-1.7333c0-.2394-.2011-.4334-.4493-.4334Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M32.8584 25.7339h-3.5945c-.4963 0-.8987.388-.8987.8667v2.6c0 .4786.4024.8667.8987.8667h3.5945c.4963 0 .8986-.3881.8986-.8667v-2.6c0-.4787-.4023-.8667-.8986-.8667Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M31.9575 26.6001h-1.7972c-.2482 0-.4494.194-.4494.4333v1.7334c0 .2393.2012.4333.4494.4333h1.7972c.2481 0 .4493-.194.4493-.4333v-1.7334c0-.2393-.2012-.4333-.4493-.4333Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Suitcase.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Suitcase"
};
validateTidalLicense();
export {
  Suitcase
};
//# sourceMappingURL=Suitcase.js.map
